import { useCallback } from 'react';
import { useSelectedProductIds } from '../useCustomerCatalogueService';

export const useValidateSelectedProducts = () => {
  const selectedProducts = useSelectedProductIds();

  return useCallback<() => string>(() => {
    if (selectedProducts.length === 0) {
      return 'Before moving to a later step, you must select at least one product.';
    }

    return "";
  }, [selectedProducts]);
};
